import React from 'react';
import { ArrowUpRight, ArrowDownLeft } from 'lucide-react';
import { Transaction } from '../data/mockData';
interface TransactionItemProps {
  transaction: Transaction;
}
export function TransactionItem({
  transaction
}: TransactionItemProps) {
  const isSale = transaction.type === 'sale';
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-NG', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  return <div className="flex items-center gap-4 py-4 group cursor-default" data-id="element-83">
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-white/[0.04] border border-white/[0.06] group-hover:bg-white/[0.08] transition-colors`} data-id="element-84">
        {isSale ? <ArrowDownLeft className="w-5 h-5 text-[#00D68F]" data-id="element-85" /> : <ArrowUpRight className="w-5 h-5 text-[#FF4757]" data-id="element-86" />}
      </div>

      <div className="flex-1" data-id="element-87">
        <p className="text-white font-medium tracking-tight" data-id="element-88">
          {transaction.description}
        </p>
        <p className="text-[#64748B] text-xs mt-1 font-medium" data-id="element-89">
          {formatDate(transaction.date)}
        </p>
      </div>

      <span className={`font-mono font-bold tracking-tight ${isSale ? 'text-[#00D68F]' : 'text-white'}`} data-id="element-90">
        {isSale ? '+' : ''}₦{Math.abs(transaction.amount).toLocaleString()}
      </span>
    </div>;
}